import Immutable from 'immutable';

import WebAppsConnection from 'sharedreact/connections/WebAppsConnection';
import WebAppsConstants from 'sharedreact/constants/WebAppsConstants';
import ErrorData from 'sharedreact/data/ErrorData';
import WebApp from 'sharedreact/data/WebApp';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

function _fetchFailure (error: ErrorData): void {
  AppDispatcher.dispatch({
    actionType: WebAppsConstants.GET_FAIL,
    error: error,
    logLevel: 'trace'
  });
}

function _fetchSuccess (items: Immutable.List<WebApp>): void {
  AppDispatcher.dispatch({
    actionType: WebAppsConstants.GET_SUCCESS,
    items: items,
    logLevel: 'trace'
  });
}

function fetch (): void {
  WebAppsConnection.fetch(_fetchSuccess, _fetchFailure);
}

function show (currentWorkspace: string, allAppsUrl?: string): void {
  AppDispatcher.dispatch({
    actionType: WebAppsConstants.SHOW,
    currentWorkspace: currentWorkspace,
    allAppsUrl: allAppsUrl,
    logLevel: 'trace'
  });
}

function hide (): void {
  AppDispatcher.dispatch({
    actionType: WebAppsConstants.HIDE,
    logLevel: 'trace'
  });
}

export default {
  fetch,
  show,
  hide,
  update: _fetchSuccess
};
